import axios from 'axios'

const AppointmentSlotService = {
  async getList (params = {}) {
    return axios.get('admin/appointment-slots', { params })
  },

  async getCalendar (params = {}) {
    return axios.get('admin/appointment-slots', { params })
  },

  async show (id) {
    return axios.get(`admin/appointment-slots/${id}`)
  },

  async store (data) {
    return axios.post('admin/appointment-slots', data)
  },

  async storeBatch (data) {
    return axios.post('admin/appointment-slots/batch', data)
  },

  async update (id, data) {
    return axios.put(`admin/appointment-slots/${id}`, data)
  },

  async destroy (id) {
    return axios.delete(`admin/appointment-slots/${id}`)
  }
}

export default AppointmentSlotService
